if($('body.single-event').length){
  if(!$('section.module').length){
    $('.footer-top').addClass('disable-margin');
  }
}

